import React, { Component } from "react";

import DataInputsLayout from "sub_components/Common/DataInputsLayout";
import LoadingCube from "sub_components/Common/LoadingCube";
import { BloxButton } from "styled_components/Common/BloxButton";
import { AvatarApi } from "services/avatar";
import { Permissions } from "services/permissions";
import { USER_UPDATE_SUCCESS, USER_UPDATE_ERROR } from "actions";
import { PHONEMASK } from "utils/Misc/CommonConstants";
import { Utils } from "services/utils";

export default class UserInfo extends Component {
  constructor(props) {
    super(props);

    this.avatarApi = new AvatarApi();
    this.state = {
      updates: [],
      pages: null,
      dataFields: null,
      data: null,
      turnOnBlueFill: false,
      className: "",
      addressError: false,
      addressErrorMessage:
        "Something went wrong. Please ensure you have entered at least 7 characters",
      job_titleError: false,
      job_titleErrorMessage:
        "Something went wrong. Please ensure you have entered at least 2 characters.",
      errorMessage: "",
      phone_numberError: false,
      phone_numberErrorMessage:
        "Something went wrong. Please ensure you have entered at least 10 numbers.",
      mobile_numberError: false,
      mobile_numberErrorMessage:
        "Something went wrong. Please ensure you have entered at least 10 numbers.",
      zipcodeError: false,
      zipcodeErrorMessage:
        "Something went wrong. Please ensure you have entered a 5 or 9 digit zipcode.",
      stateError: false,
      stateErrorMessage:
        "Something went wrong. Please ensure you have entered at least 2 characters.",
      cityError: false,
      cityErrorMessage:
        "Something went wrong. Please ensure you have entered at least 3 characters.",
      job_title_active: false,
      work_number_active: false,
      mobile_number_active: false,
      zipcode_active: false,
      state_active: false,
      city_active: false,
      address_active: false,
      building_active: false,
      showError: false,
      showMask: false,
    };
  }

  sanitizeResponse(response) {
    let firstname = "",
      lastname = "",
      job_title = "";
    let phone_number = "",
      mobile_number = "",
      email = "";
    let address = "",
      building = "",
      city = "",
      state = "",
      zipcode = "";
    let avatar = null;

    if (response) {
      firstname = response?.firstname;
      lastname = response?.lastname;
      job_title = response?.job_title;
    }

    if (response && response.userProfile) {
      const profile = response.userProfile;

      avatar = profile.profileImage;
    }

    if (response && response.contactDetails) {
      const details = response.contactDetails;
      phone_number = details.phone_number || "";
      (mobile_number = details.mobile_number || ""),
        (email = details.email || "");
      address = details.address || "";
      city = details.city || "";
      building = details.building || "";
      state = details.state || "";
      zipcode = details.zipcode || "";
    }

    return {
      firstname,
      lastname,
      job_title,
      phone_number,
      mobile_number,
      email,
      address,
      building,
      city,
      state,
      zipcode,
      avatar,
    };
  }

  generateUserFields() {
    const {
      data,
      job_titleError,
      job_title_active,
      phone_numberError,
      phone_number_active,
      mobile_number_active,
      mobile_numberError,
      address_active,
      addressError,
      building_active,
      buildingError,
      city_active,
      cityError,
      state_active,
      stateError,
      zipcode_active,
      zipcodeError,
    } = this.state;
    if (!data) return;

    const dataFields = {};
    const {
      job_title,
      phone_number,
      mobile_number,
      email,
      address,
      building,
      city,
      state,
      zipcode,
    } = data;
    const { pages, profile } = this.props;

    const hasEditJobAccess = Permissions.checkComponentAccess(
      pages,
      "My Profile",
      "edit-job"
    );
    const hasEditAddressAccess = Permissions.checkComponentAccess(
      pages,
      "My Profile",
      "edit-address"
    );
    const hasEditCellPhoneAccess = Permissions.checkComponentAccess(
      pages,
      "My Profile",
      "edit-cellphone"
    );
    const hasEditWorkPhoneAccess = Permissions.checkComponentAccess(
      pages,
      "My Profile",
      "edit-workphone"
    );

    const jobAccess = hasEditJobAccess ? true : false;
    const addressAccess = hasEditAddressAccess ? true : false;
    const cellphoneAccess = hasEditCellPhoneAccess ? true : false;
    const workphoneAccess = hasEditWorkPhoneAccess ? true : false;

    const name = profile?.firstname + " " + profile?.lastname;
    dataFields.contactInfoData = [
      {
        name: "NAME",
        value: name,
        propName: "firstname",
        readonly: true,
        active: false,
        error: false,
      },
      {
        name: "TITLE",
        value: job_title,
        propName: "job_title",
        readonly: !jobAccess,
        active: job_title_active,
        error: job_titleError,
      },
    ];
    dataFields.phoneData = [
      {
        name: "WORK",
        value: phone_number,
        propName: "phone_number",
        active: phone_number_active,
        error: phone_numberError,
        readonly: !workphoneAccess,
      },
      {
        name: "MOBILE",
        value: mobile_number,
        propName: "mobile_number",
        active: mobile_number_active,
        error: mobile_numberError,
        readonly: !cellphoneAccess,
      },
    ];
    dataFields.emailData = [
      { name: "EMAIL", value: email, readonly: true, propName: "email" },
    ];
    dataFields.addressData = [
      {
        name: "STREET",
        value: address,
        propName: "address",
        active: address_active,
        error: addressError,
        readonly: !addressAccess,
      },
      {
        name: "SUITE",
        value: building,
        propName: "building",
        active: building_active,
        error: buildingError,
        readonly: !addressAccess,
      },
      {
        name: "CITY",
        value: city,
        propName: "city",
        active: city_active,
        error: cityError,
        readonly: !addressAccess,
      },
    ];
    dataFields.addressData2 = [
      {
        name: "STATE",
        value: state,
        propName: "state",
        active: state_active,
        error: stateError,
        readonly: !addressAccess,
      },
      {
        name: "ZIP",
        value: zipcode,
        propName: "zipcode",
        active: zipcode_active,
        error: zipcodeError,
        readonly: !addressAccess,
      },
    ];

    this.setState({ dataFields });
  }

  componentDidMount() {
    const { profile } = this.props;
    const { dataFields } = this.state;

    if (profile && !dataFields) {
      const sanitizedInputs = this.sanitizeResponse(profile);

      this.setState({
        data: sanitizedInputs,
        originalData: sanitizedInputs,
      });

      this.generateUserFields(sanitizedInputs);
    }
  }

  componentDidUpdate() {
    const { data, dataFields } = this.state;
    const { pages } = this.props;
    if (data && !dataFields && pages?.permissions) {
      this.generateUserFields();
      if (data.zipcode && data.zipcode.length > 5) {
        this.setState({ showMask: true });
      }
    }
  }

  validateNumberInput = (newValue) => {
    return (newValue.length >= 10 &&
      newValue.length !== 0 &&
      newValue.match(/^[0-9\-]+$/)) ||
      newValue.length === 0
      ? USER_UPDATE_SUCCESS
      : USER_UPDATE_ERROR;
  };

  validateZipcode = (newValue) => {
    return (newValue.length === 5 &&
      newValue.length !== 0 &&
      newValue.match(/^[a-zA-Z0-9]*$/)) ||
      newValue.length === 0 ||
      (newValue.length === 9 &&
        newValue.length !== 0 &&
        newValue.match(/^[a-zA-Z0-9]*$/))
      ? USER_UPDATE_SUCCESS
      : USER_UPDATE_ERROR;
  };

  validateJobTitle = (newValue) => {
    return (newValue.length >= 2 && newValue.length !== 0) ||
      newValue.length === 0
      ? USER_UPDATE_SUCCESS
      : USER_UPDATE_ERROR;
  };

  validateState = (newValue) => {
    return (newValue.length >= 2 && newValue.length !== 0) ||
      newValue.length === 0
      ? USER_UPDATE_SUCCESS
      : USER_UPDATE_ERROR;
  };

  validateCity = (newValue) => {
    return (newValue.length >= 3 && newValue.length !== 0) ||
      newValue.length === 0
      ? USER_UPDATE_SUCCESS
      : USER_UPDATE_ERROR;
  };

  onChange = (event) => {
    const {
      dataset: { fieldname },
      value,
    } = event.target;

    if (fieldname === "zipcode" && value.length > 5) {
      let newValue = value;
      if (!value.includes("-")) {
        newValue = newValue.slice(0, 5) + "-" + newValue.slice(5, 9);
      }

      const data = { ...this.state.data, [fieldname]: newValue };
      this.setState({ data }, () => this.generateUserFields());
    } else {
      const data = { ...this.state.data, [fieldname]: value };
      this.setState({ data }, () => this.generateUserFields());
    }
  };

  validateUserInput(fieldname, value, changeParams) {
    let updateStatus;
    let newValue = value;

    switch (fieldname) {
      case "phone_number":
        newValue = newValue.replace(/[^0-9]/g, "");
        updateStatus = this.validateNumberInput(newValue);
        break;
      case "mobile_number":
        newValue = newValue.replace(/[^0-9]/g, "");
        updateStatus = this.validateNumberInput(newValue);
        break;
      case "building":
        updateStatus = USER_UPDATE_SUCCESS;
        break;
      case "address":
        updateStatus = USER_UPDATE_SUCCESS;
        break;
      case "zipcode":
        newValue = newValue.replace("-", "");
        updateStatus = this.validateZipcode(newValue);
        break;
      case "job_title":
        updateStatus = this.validateJobTitle(newValue);
        break;
      case "state":
        updateStatus = this.validateState(newValue);
        break;
      case "city":
        updateStatus = this.validateCity(newValue);
        break;
      default:
        break;
    }
    if (updateStatus === USER_UPDATE_SUCCESS) {
      const { updates } = this.state;
      const componentIndex = updates.findIndex(
        (x) => Object.keys(x)[0] === Object.keys(changeParams)[0]
      );
      let addToUpdates = true;
      for (let i = 0; i < updates.length; i++) {
        if (Object.keys(changeParams)[0] in updates[i]) {
          this.setState(
            // eslint-disable-next-line
            (state) => (state.updates[componentIndex] = changeParams)
          );
          addToUpdates = false;
        }
      }
      if (addToUpdates) {
        const newUpdates = [...updates];
        newUpdates.push(changeParams);
        this.setState({ updates: newUpdates });
      }
      this.clearErrorField(fieldname);
    } else if (updateStatus === USER_UPDATE_ERROR) {
      const fieldErrorMessage = `${fieldname}ErrorMessage`;

      const errorMessage = this.state[fieldErrorMessage];
      this.setState(
        {
          [`${fieldname}Error`]: true,
          showError: true,
          errorMessage,
        },
        () => this.generateUserFields()
      );
    }
  }

  saveInformation = () => {
    const { updates } = this.state;
    const { updateUser } = this.props;
    for (let i = 0; i < updates.length; i++) {
      const promise = updateUser(updates[i]);
      const fieldname = Object.keys(updates[i])[0];

      promise.then((response) => {
        if (response) {
          if (response.status === 200 && response.data.error === null) {
            this.clearErrorField(fieldname);
          } else {
            this.setState(
              {
                [`${fieldname}Error`]: true,
                showError: true,
                errorMessage:
                  "Looks like something went wrong on our end. If the problem persists please call 877-590-1684",
              },
              () => this.generateUserFields()
            );
          }
        } else {
          this.setState(
            {
              [`${fieldname}Error`]: true,
              showError: true,
              errorMessage:
                "Looks like something went wrong on our end. If the problem persists please call 877-590-1684",
            },
            () => this.generateUserFields()
          );
        }
      });
    }
  };

  clearErrorField(fieldname) {
    this.setState({ [`${fieldname}Error`]: false, showError: false }, () =>
      this.generateUserFields()
    );
  }

  onFocusPhone = (event) => {
    const valueScrub = Utils.scrubPhoneNumber(event.target.value);

    if (
      valueScrub === "" ||
      valueScrub === undefined ||
      valueScrub === null ||
      valueScrub === "undefined"
    ) {
      // eslint-disable-next-line
      event.target.value = "";
    }
  };

  onBlur = (event) => {
    const {
      dataset: { fieldname },
    } = event.target;
    const { data } = this.state;
    const newValue = data[fieldname];

    if (data[fieldname] || newValue === "") {
      const changeParams = {
        [fieldname]: newValue,
      };
      this.validateUserInput(fieldname, newValue, changeParams);
    }
  };

  renderProfileCard() {
    const { errorMessage, showError, className, dataFields } = this.state;
    const { breakpoint } = this.props;

    return (
      <div className="user-profile-card">
        <div className="contact-card2">
          <div className="main-section">
            <div className="sub-section">
              <div className="main-heading heading60"></div>
              <div className="title heading70">Contact</div>
              <div className="fields">
                <DataInputsLayout
                  className={className}
                  data={dataFields.contactInfoData}
                  onBlurHandler={this.onBlur}
                  isChangedHandler={this.onChange}
                  showDivider={true}
                />
                <DataInputsLayout
                  className={className}
                  data={dataFields.phoneData}
                  onBlurHandler={this.onBlur}
                  isChangedHandler={this.onChange}
                  onFocusHandler={this.onFocusPhone}
                  mask={PHONEMASK}
                  showDivider={true}
                />
              </div>
            </div>
            <div className="sub-section">
              <div className="title heading70">Address</div>
              <div className="fields">
                <DataInputsLayout
                  className={className}
                  data={dataFields.addressData}
                  onBlurHandler={this.onBlur}
                  isChangedHandler={this.onChange}
                  maxLength={10}
                  showDivider={true}
                />
                <div className="small-fields">
                  <DataInputsLayout
                    className={className}
                    data={dataFields.addressData2}
                    onBlurHandler={this.onBlur}
                    isChangedHandler={this.onChange}
                    maxLength={10}
                    showDivider={true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-section">
            {showError && <div className="error body10">{errorMessage}</div>}
            <BloxButton
              id="button-9"
              text="SAVE"
              breakpoint={breakpoint}
              module="account"
              enabled={!showError}
              className="user-info-save buttons41"
              onClick={this.saveInformation}
              cypressId="save-user-info"
            />
          </div>
        </div>
      </div>
    );
  }

  renderLoadingCard() {
    return <LoadingCube />;
  }

  render() {
    const { dataFields } = this.state;

    return (
      <div className="user-information">
        {dataFields && this.renderProfileCard()}
        {!dataFields && this.renderLoadingCard()}
      </div>
    );
  }
}
